<script>
export const pageName = 'validate';
export const pageRoute = '/validate/{userId}';
export const title = 'Validate Membership'
export const requireMembership = false;
export const requireCompleteAccount = true;

import { certLevelToLevel, rsoLevelToLevel, attemptTypeToFullAttempt } from '../../../functions/domain/certification-utils.js';
import { queries } from '../../js/lib/functions.js'
import { getLevelName } from '../../../functions/domain/map/map.js';
import { PageShowError } from '@trullock/page-manager';
import ukraLogo from '../../img/ukra-logo.png'

export default {
	data() {
		return { 
			user: null,
			ukraLogo,
			ready: false
		}
	},

	methods: {
		getLevelName,
		async boot(opts)
		{
			this.user = await queries.users.account.validate({ userId: opts.userId });
			if(!this.user.success)
			{
				// TODO: 404 support
				throw new PageShowError('/', 'User not found', {}, 'replace');
			}

			this.ready = true;
		},
		stageBadgeText(stage)
		{
			return stage.status == 'pending' ? 'Awaiting UKRA Validation' : 
				stage.status == 'passed' ? 'Passed' : 
				'Not started'
		},
		stageBadgeClass(stage)
		{
			return stage.status == 'pending' ? 'badge-secondary' : 
				stage.status == 'passed' ? 'badge-success' : 
				'badge-light'
		},
		rsoLevelToLevel,
		certLevelToLevel,
		attemptTypeToFullAttempt
	}
}

</script>
<template>
	<div v-if="ready" class="container py-5">
		<div class="row justify-content-center">

			<div class="col col-12 col-lg-8">
				<div class="card py-5 py-lg-7">
					<div class="card-body text-center">

						<div class="avatar avatar-xxl mb-3">
							<img :src="user.avatar" class="avatar-img rounded-circle border border-4 border-card" alt="...">
						</div>

						<h2 class="card-title">
							{{ user.name }}
						</h2>
						<h3 class="card-title mb-5">
							#{{ user.number }}
						</h3>

						<div class="text-secondary mb-3">
							<span v-if="user.membership.status == 'active'" class="badge badge-success badge-lg"> <span class="fe fe-check-circle"></span> Active Member</span>
							<span v-if="user.membership.status == 'expired'" class="badge badge-danger badge-lg"><span class="fe fe-x-circle"></span> Expired Member</span>
							<span v-if="user.membership.status == 'non-member'" class="badge badge-danger badge-lg"><span class="fe fe-x-circle"></span> Non-Member</span>
						</div>
						<div class="text-secondary mb-3">
							<span v-if="user.insurance.status == 'active'" class="badge badge-success badge-lg"><span class="fe fe-check-circle"></span> Insurance Valid</span>
							<span v-else-if="user.insurance.status == 'expired'" class="badge badge-danger badge-lg"><span class="fe fe-x-circle"></span> Insurance Expired</span>
							<span v-else class="badge badge-warning badge-lg"><span class="fe fe-x-circle"></span> Insurance Not Validated</span>
						</div>
						<span v-if="user.ukra.role" class="badge badge-lg badge-ds mb-3"><img :src="ukraLogo" alt="UKRA Logo" /> UKRA {{ user.ukra.role }}</span>
						<div v-if="user.certification.level" class="card-text mb-3">
							<span class="badge badge-success badge-lg"><span class="fe fe-award"></span> HPR {{ certLevelToLevel(user.certification.level) }}</span>
						</div>
						<div v-if="user.rso.level" class="card-text mb-3">
							<span v-if="user.rso.level" class="badge badge-ds badge-lg"><span class="fe fe-shield"></span> {{ rsoLevelToLevel(user.rso.level) }} RSO</span>
						</div>
						<div v-if="user.map.isAssessor" class="card-text mb-3">
							<span class="badge badge-ds badge-lg"><span class="fe fe-check-square"></span> MAP Assessor</span>
						</div>
						<div class="text-center mb-3">
							MAP Rank: {{ getLevelName(user.map.level) }}
						</div>
						<div v-if="user.certification.level != 'level3'">
							<hr class="my-5" />
							<p>Eligible for:</p>
							<span v-if="user.rso.level" class="badge badge-ds badge-lg">{{ attemptTypeToFullAttempt(user.certification.nextStage) }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>
